import { render } from "./VehicleMaster.vue?vue&type=template&id=ffc3b77e&scoped=true"
import script from "./VehicleMaster.vue?vue&type=script&lang=js"
export * from "./VehicleMaster.vue?vue&type=script&lang=js"

import "./VehicleMaster.vue?vue&type=style&index=0&id=ffc3b77e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc3b77e"]])

export default __exports__